<template>
  <div
    class="panel"
    :light="isLightTheme"
  >
    <div class="top-panel__logo">
      <div class="logo">
        <div class="cursor">
          <AuIcon
            v-if="!showMenu"
            icon="toggler"
            @click="showMenu=true"
          />
          <AuIcon
            v-else
            icon="close"
            @click="showMenu=false"
          />
        </div>
        <div
          class="line"
        />
        <AuIcon :icon="mobileLogo" />
        <span
          v-if="showTestnet"
          class="testnet-mobile"
          :dark="!isLightTheme"
        >
          Testnet
        </span>
      </div>
    </div>

    <div class="top-panel__info">
      <div class="top-panel__center">
        <div
          v-if="loginAsTester"
          :style="{ background: isTestRole ? 'yellow' : '#f2f1f7' }"
          class="login-as-tester"
          @click="changeTestRole"
        >
          TEST<span
            class="hide"
          >{{ roleStr }}
          </span>
          <AuIcon
            v-if="isTestRole"
            icon="yes"
            class="role_icon"
          />
          <AuIcon
            v-else
            icon="no"
            class="role_icon"
          />
        </div>
        <div
          v-if="loginAsAdmin"
          class="login-as-admin"
        >
          <span class="hide">{{ loggedStr }}</span>ADMIN
        </div>
      </div>
      <AuSelect
        v-if="isTestRole"
        :value="platform"
        :options="platformOpt"
        class="type-select"
        :placeholder="'Platform'"
        @input="changePLatform"
      />
    </div>



    <div class="top-panel__right">
      <Profile />
      <ThemeSwitcher />
      <Notifications v-if="isTestRole" />
    </div>
    <div
      v-if="showMenu"
      class="menu-mobile"
    >
      <TestPageMenu v-if="isTestPage" />
      <Menu
        v-else
        adaptive
        @close="showMenu=false"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Menu from "@/components/menu/Menu";
import Notifications from "./components/Notifications";
import Profile from "./components/Profile.vue";
import TestPageMenu from "@/components/menu/TestPageMenu.vue";
import ThemeSwitcher from "./components/ThemeSwitcher";
import { changeRole, checkTestRole } from "@/help/isUserRole";
import { mapGetters } from "vuex";

export default {
  components: {
    Menu,
    Profile,
    ThemeSwitcher,
    Notifications,
    TestPageMenu
  },

  data() {
    return {
      showMenu: false,
      platform: "",
      platformOpt: [
        { display: "Default", value: process.env.VUE_APP_PLATFORM },
        { display: "Autentic", value: "Autentic" },
        { display: "RWA.Capital", value: "RWA.Capital" }
      ]
    };
  },

  computed: {
    ...mapGetters({
      isLightTheme: "isLightTheme",
      profile: "profile/profile",
      isTestRole: "profile/isTestRole",
      language: "language"
    }),

    isTestPage() {
      return this.$route.name == "TestPage";
    },

    loginAsAdmin() {
      return this.$cookies.get("is_login_in");
    },
    loginAsTester() {
      return _.some(this.profile.roles, role => role == "ROLE_TEST");
    },

    showTestnet() {
      return process.env.VUE_APP_SHOW_TESTNET == 1;
    },

    mobileLogo() {
      return process.env.VUE_APP_AUT_LOGO_MOBILE || "logo_mobile.v2";
    },

    roleStr() {
      return `_ROLE ${this.isTestRole ? (this.language === "en" ? "enabled" : "активирована") : (this.language === "en" ? "disabled" : "выключена")}`;
    },

    loggedStr() {
      return this.language === "en" ? "Logged as " : "Зарегистрирован как ";
    }
  },
  mounted() {
    checkTestRole();
  },
  methods: {
    changeTestRole() {
      changeRole();
    },

    changePLatform(value) {
      console.log("value", value);
    }
  }
};
</script>

<style scoped lang="scss">
.panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 25px;
  height: 66px;

  border-bottom: 1px solid var(--color-90);

  @media screen and (max-width:640px) {
    border-color: var(--color-70);
  };
  @media screen and (max-width:376px) {
    padding: 25px 18px;
  };

  &[light=true] {
    background-color: white;
  }
  .top-panel__info{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
    margin-left: 10px;
  }
  .top-panel__center {
    display: flex;
    align-items: start;
    justify-content: flex-start;

    @media screen and (max-width:1024px) {
      flex-direction: column;
      align-items: center;
    };
  }
  .top-panel__right {
    display: flex;
    align-items: center;
    gap: 24px;
    @media screen and (max-width:415px) {
      gap: 10px;
    };
  }
}

.current-page {
  display: block;
  font-size: 16px;

  @media screen and (max-width:1024px) {
    display: none;
  }
}

.top-panel__logo {
  height: 66px;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
  white-space: nowrap;
}

.logo {
  height: 66px;
  display: none;

  @media screen and (max-width:1200px) {
    display: flex;
    align-items: center;
    >div:first-child{
      width: 46px;
    }
  }
}

.line {
  height: 100%;
  border-right: 1px solid var(--color-90);
  margin-right: 22px;
}

.cursor {
  >img{
    cursor: pointer;
  }
}

.section {
  font-size: 14px;
  text-decoration: none;
  color: var(--text-color);
  white-space: nowrap;

  &:hover {
    color: var(--color-60);
  }
}

.sections {
  display: flex;
  flex-direction: row;
  gap: 50px;

  @media screen and (max-width:1024px) {
    display: none;
  }

  &-mobile {
    display: none;
    position: relative;

    @media screen and (max-width:1024px) {
      display: block;
    }

    @media screen and (max-width:640px) {
      display: none;
    }
  }

  &-selector {
    margin-left: 10px;
  }

  &-menu {
    position: fixed;
    top: 60px;
    z-index: 100;
    background-color: var(--menu-color);
    border-radius: 20px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 17px;
  }
}

.router-link-active {
  color: #279063;
}

.testnet-mobile {
  margin-top: -14px;
  margin-left: 4px;
  font-size: 12px;
  color: #00000060;
  &[dark=true] {
    color: #FFFFFF80;
  }
}

.menu-mobile {
  display: none;
  position: absolute;
  top: 66px;
  left: 0;
  width: 100%;
  height: calc(100% - 69px);
  background: var(--main-color);
  border-bottom: 1px solid var(--color-90);
  z-index: 2000;
  padding: 25px;
  @media screen and (max-width: 1200px){
    display: flex;
    flex-direction: column;
    gap: 22px;
  }

  .text {
    display: flex;
    flex-direction: column;
  }

  .item {
    display: flex;
    align-items: start;
    gap: 15px;
  }

  .title {
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 2px;
    text-decoration: none;
    color: var(--text-color);
    &[green=true] {
      color: #279063
    }
  }

  .sub-title {
    font-size: 12px;
    line-height: 12px;
    color: var(--color-50)
  }
}

.login-as-admin {
  color: #121212;
  font-size: 16px;
  background: red;
  padding: 2px 12px;
  border-radius: 4px;
  @media screen and (max-width:1024px) {
    font-size: 12px;
    min-width: 50px;
    text-align: center;
    padding: 2px 6px
  }
}
.login-as-tester {
  color: #121212;
  font-size: 16px;
  padding: 2px 12px;
  border-radius: 4px;
  transition: background 0.3s ease;
  cursor: pointer;

  @media screen and (max-width:1024px) {
    font-size: 12px;
    min-width: 50px;
    text-align: center;
    padding: 2px 6px
  }
  @media screen and (max-width:415px) {
    margin-left: 4px;
  }
}
.hide {
  @media screen and (max-width:1024px) {
    display: none;
  }
}
.role_icon {
  width: 10px;
  height: 10px;
  display: none;
  margin-left: 2px;
  @media screen and (max-width:1024px) {
    display: inline-flex;
  }
}
.type-select {
  width: 100px;
}

</style>
